export const AdminHeader = ({ title, sub, children }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
    <div>
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-emerald-400">Platform</p>
      <h1 className="mt-1 text-3xl font-extrabold uppercase text-white sm:text-4xl">{title}</h1>
      {sub && <p className="mt-1 text-sm text-slate-400">{sub}</p>}
    </div>
    {children}
  </div>
);
